import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {INewsPost} from '@api/models/news/news';
import {ContentCardAlignment, ContentCardLayout} from '@lib-modules/cards/components/content-card/content-card.component';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {SectionHeaderTitleSize} from '@lib-modules/section/components/section-header/section-header.component';
import {IMAGE_RESOLUTION} from '@api/models/image/image-resolution';

export enum NewsSectionLayout {
  Row = 'row-layout',
  RowThumbnail = 'row-thumbnail-layout',
  Column = 'column-layout',
  Mixed = 'mixed-layout',
}

@Component({
  selector: 'lib-news-section',
  templateUrl: './news-section.component.html',
  styleUrls: [
    './news-section.component.scss',
    '../../styles/section-styles.scss'
  ]
})
export class NewsSectionComponent implements OnInit, OnChanges {

  public compactCardLayout = ContentCardLayout.Compact;
  public splitCardLayout = ContentCardLayout.Split;

  @Input() public lazyLoadImages = true;
  @Input() public newsList: INewsPost[];
  @Input() public title: string;
  @Input() public titleIcon: string;
  @Input() public layout: NewsSectionLayout;
  @Input() public colorScheme = ColorScheme.Dark;
  @Input() public titleSize = SectionHeaderTitleSize.Large;
  @Input() public moreButtonLink: string;
  @Input() public moreButtonRouterLink: string;
  @Input() public moreButtonTitle = "Mehr News";
  @Input() public showMoreButton = false;
  @Output() public loadMoreClick = new EventEmitter();

  public compactNews = [];
  public squareNews = [];
  public splitNews = [];
  public splitCardAlignment = ContentCardAlignment.Left;
  public largeImageRes = IMAGE_RESOLUTION.HIGH;

  constructor() { }

  public ngOnInit(): void {
    this.init();
    if (this.layout === NewsSectionLayout.Column) {
      this.splitCardAlignment = ContentCardAlignment.Right;
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.newsList) {
      this.init();
    }
  }

  private init(): void {
    if (!this.newsList || this.newsList?.length === 0) {
      return;
    }
    switch (this.layout) {
      case NewsSectionLayout.Row:
      case NewsSectionLayout.RowThumbnail:
        this.squareNews = this.newsList;
        break;
      case NewsSectionLayout.Column:
        this.splitNews = this.newsList;
        break;
      case NewsSectionLayout.Mixed:
        this.compactNews = [this.newsList[0]];
        this.splitNews = this.newsList.slice(1, 4);
        break;
    }
  }

  public get squareCardLayout(): ContentCardLayout {
    if (this.layout === NewsSectionLayout.RowThumbnail) {
      return ContentCardLayout.SquareThumbnail;
    }
    return ContentCardLayout.Square;
  }
}
